/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UploadTaskOverview
 */
export interface UploadTaskOverview {
  /**
   *
   * @type {string}
   * @memberof UploadTaskOverview
   */
  readonly uuid?: string;
  /**
   *
   * @type {UploadTaskOverviewStatusEnum}
   * @memberof UploadTaskOverview
   */
  status?: UploadTaskOverviewStatusEnum;
  /**
   *
   * @type {UploadTaskOverviewBroDomainEnum}
   * @memberof UploadTaskOverview
   */
  broDomain?: UploadTaskOverviewBroDomainEnum;
  /**
   *
   * @type {UploadTaskOverviewRegistrationTypeEnum}
   * @memberof UploadTaskOverview
   */
  registrationType: UploadTaskOverviewRegistrationTypeEnum;
  /**
   *
   * @type {UploadTaskOverviewRequestTypeEnum}
   * @memberof UploadTaskOverview
   */
  requestType: UploadTaskOverviewRequestTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof UploadTaskOverview
   */
  readonly created?: Date;
  /**
   *
   * @type {string}
   * @memberof UploadTaskOverview
   */
  log?: string;
  /**
   *
   * @type {string}
   * @memberof UploadTaskOverview
   */
  broErrors?: string;
}

/**
 * @export
 */
export const UploadTaskOverviewStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type UploadTaskOverviewStatusEnum =
  (typeof UploadTaskOverviewStatusEnum)[keyof typeof UploadTaskOverviewStatusEnum];

/**
 * @export
 */
export const UploadTaskOverviewBroDomainEnum = {
  Gmn: "GMN",
  Gmw: "GMW",
  Gld: "GLD",
  Frd: "FRD",
  Gar: "GAR",
  Cpt: "CPT",
  Bhr: "BHR",
  Guf: "GUF",
  Gpd: "GPD",
} as const;
export type UploadTaskOverviewBroDomainEnum =
  (typeof UploadTaskOverviewBroDomainEnum)[keyof typeof UploadTaskOverviewBroDomainEnum];

/**
 * @export
 */
export const UploadTaskOverviewRegistrationTypeEnum = {
  GmnStartRegistration: "GMN_StartRegistration",
  GmnMeasuringPoint: "GMN_MeasuringPoint",
  GmnMeasuringPointEndDate: "GMN_MeasuringPointEndDate",
  GmnTubeReference: "GMN_TubeReference",
  GmnClosure: "GMN_Closure",
  GmwConstruction: "GMW_Construction",
  GmwElectrodeStatus: "GMW_ElectrodeStatus",
  GmwGroundLevel: "GMW_GroundLevel",
  GmwGroundLevelMeasuring: "GMW_GroundLevelMeasuring",
  GmwInsertion: "GMW_Insertion",
  GmwLengthening: "GMW_Lengthening",
  GmwShortening: "GMW_Shortening",
  GmwPositions: "GMW_Positions",
  GmwPositionsMeasuring: "GMW_PositionsMeasuring",
  GmwShift: "GMW_Shift",
  GmwMaintainer: "GMW_Maintainer",
  GmwOwner: "GMW_Owner",
  GmwRemoval: "GMW_Removal",
  GmwSubsequentAdditionalSurvey: "GMW_SubsequentAdditionalSurvey",
  GmwTubeStatus: "GMW_TubeStatus",
  GmwWellHeadProtector: "GMW_WellHeadProtector",
  Gar: "GAR",
  GldStartRegistration: "GLD_StartRegistration",
  GldAddition: "GLD_Addition",
  GldClosure: "GLD_Closure",
  FrdStartRegistration: "FRD_StartRegistration",
  FrdGemMeasurementConfiguration: "FRD_GEM_MeasurementConfiguration",
  FrdGemMeasurement: "FRD_GEM_Measurement",
  FrdEmmInstrumentConfiguration: "FRD_EMM_InstrumentConfiguration",
  FrdEmmMeasurement: "FRD_EMM_Measurement",
  FrdClosure: "FRD_Closure",
  Cpt: "CPT",
  BhrP: "BHR-P",
  BhrG: "BHR-G",
  BhrGt: "BHR-GT",
  Sfr: "SFR",
  GufStartRegistration: "GUF_StartRegistration",
  GufNewLicense: "GUF_NewLicense",
  GufExpandedRealisedInstallation: "GUF_ExpandedRealisedInstallation",
  GufWellFunction: "GUF_WellFunction",
  GufHeight: "GUF_Height",
  GufClosure: "GUF_Closure",
  GufAddRealisedInstallation: "GUF_AddRealisedInstallation",
  GufClosureRealisedPart: "GUF_ClosureRealisedPart",
  GpdStartRegistration: "GPD_StartRegistration",
  GpdAddReport: "GPD_AddReport",
  GpdEndRegistration: "GPD_EndRegistration",
} as const;
export type UploadTaskOverviewRegistrationTypeEnum =
  (typeof UploadTaskOverviewRegistrationTypeEnum)[keyof typeof UploadTaskOverviewRegistrationTypeEnum];

/**
 * @export
 */
export const UploadTaskOverviewRequestTypeEnum = {
  Registration: "registration",
  Replace: "replace",
  Move: "move",
  Insert: "insert",
  Delete: "delete",
} as const;
export type UploadTaskOverviewRequestTypeEnum =
  (typeof UploadTaskOverviewRequestTypeEnum)[keyof typeof UploadTaskOverviewRequestTypeEnum];

/**
 * Check if a given object implements the UploadTaskOverview interface.
 */
export function instanceOfUploadTaskOverview(value: object): value is UploadTaskOverview {
  if (
    (!("registrationType" in (value as Record<string, any>)) &&
      !("registration_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["registrationType"] === undefined &&
      (value as Record<string, any>)["registration_type"] === undefined)
  )
    return false;
  if (
    (!("requestType" in (value as Record<string, any>)) &&
      !("request_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["requestType"] === undefined &&
      (value as Record<string, any>)["request_type"] === undefined)
  )
    return false;
  return true;
}

export function UploadTaskOverviewFromJSON(json: any): UploadTaskOverview {
  return UploadTaskOverviewFromJSONTyped(json, false);
}

export function UploadTaskOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UploadTaskOverview {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    status: json["status"] == null ? undefined : json["status"],
    broDomain: json["bro_domain"] == null ? undefined : json["bro_domain"],
    registrationType: json["registration_type"],
    requestType: json["request_type"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    log: json["log"] == null ? undefined : json["log"],
    broErrors: json["bro_errors"] == null ? undefined : json["bro_errors"],
  };
}

export function UploadTaskOverviewToJSON(json: any): UploadTaskOverview {
  return UploadTaskOverviewToJSONTyped(json, false);
}

export function UploadTaskOverviewToJSONTyped(
  value?: Omit<UploadTaskOverview, "uuid" | "created"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    status: value["status"],
    bro_domain: value["broDomain"],
    registration_type: value["registrationType"],
    request_type: value["requestType"],
    log: value["log"],
    bro_errors: value["broErrors"],
  };
}
